function extractSlidesFromAddOn(addOn) {
  let slides = []

  if(addOn.attributes.primaryImage) {
    slides.push({ type: "image", url: addOn.attributes.primaryImage.videoVariant })
  }

  addOn.attributes.additionalImages.forEach(image => {
    slides.push({ type: "image", url: image.videoVariant })
  })

  return slides
}

export default extractSlidesFromAddOn
